var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M12.582 8.675L5.89 2.902c-.25-.214-.616-.02-.616.326v11.545c0 .346.366.54.616.325l6.693-5.773a.44.44 0 000-.65z","fill":_vm.$props.fill}})])}
var staticRenderFns = []

export { render, staticRenderFns }